import { render, staticRenderFns } from "./ModalLoginOrRegister.vue?vue&type=template&id=4c9422a4&scoped=true"
import script from "./ModalLoginOrRegister.vue?vue&type=script&lang=js"
export * from "./ModalLoginOrRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9422a4",
  null
  
)

export default component.exports